import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchUserInformation } from 'redux-store/thunk/user.thunk'
import 'redux-store/store'
import { getGameSetting } from 'redux-store/thunk/gameSettings.thunk'
import { setGameCurrencyInfo } from 'redux-store/redux/slices/gameSettings.slice'
import { userLogin } from 'redux-store/thunk/auth.thunk'
import { CURRENCIES, DEFAULT_GAME_NAME, LANGUAGE, LANGUAGES } from 'utils/constants/index'
import { useLocation, useHistory } from 'react-router-dom'
import i18n from 'translation/index'
import { setDemoMode } from 'redux-store/redux/slices/auth.slice'
import { setLocalLanguage } from 'utils/common-services/localstorage.service'

const NewHeader = () => {
  const dispatch = useDispatch()
  const { search } = useLocation()
  const history = useHistory()
  const currencyCode = new URLSearchParams(search).get('currencyCode')
  const playerToken = new URLSearchParams(search).get('token')
  const gameId = new URLSearchParams(search).get('gameId')
  const operatorId = new URLSearchParams(search).get('operatorId')
  const language = new URLSearchParams(search).get('languageId')
  const demoMode = new URLSearchParams(search).get('moneyMode') && new URLSearchParams(search).get('moneyMode') !== 'real'

  const { userInfo, isLoggedIn } = useSelector((state) => state.auth)

  const handleLoginUser = () => {
    const params = {
      payload: {
        operatorId: operatorId,
        operatorUserToken: playerToken,
        currencyCode,
        gameId: DEFAULT_GAME_NAME[gameId]
      },
      history
    }
    dispatch(userLogin(params))
  }

  useEffect(() => {
    if (language) {
      i18n.changeLanguage(language || LANGUAGES[0]?.languageCode)
      setLocalLanguage(LANGUAGE, language)
    }

    if (currencyCode) {
      dispatch(setGameCurrencyInfo({
        isFiatCurrency: CURRENCIES[currencyCode]?.isFiat,
        currencyPrecision: CURRENCIES[currencyCode]?.precision
      }))
    }

    if (playerToken) {
      handleLoginUser()
      demoMode && dispatch(setDemoMode(!!(demoMode)))
    } else if (demoMode) {
      dispatch(setDemoMode(!!(demoMode)))
      dispatch(getGameSetting({ gameId: DEFAULT_GAME_NAME[gameId], demoMode }))
    }
  }, [playerToken, currencyCode, demoMode])

  useEffect(() => {
    if (isLoggedIn && !userInfo) {
      dispatch(fetchUserInformation())
    }
  }, [isLoggedIn, userInfo])

  return (
    <></>
  )
}

export default NewHeader
